export default [
  {
    text: 'EAN',
    value: 'ean',
  },
  {
    text: 'Nb UC/UL',
    value: 'hyperLogisticUnitList',
    class: 'greenColor',
  },
]
